module.exports = __webpack_public_path__ + "27ed735d350c3de2415b6ca4c6f2ca68.jpg";